module.exports = __webpack_public_path__ + "images/smoked.png";